import { useCallback, useMemo, useState } from "react";
import { getRefreshedAccessToken } from "@/util/auth";
import { handleApiError } from "@/util/error-handlers";
import { deviceType, getReactNativeAppVersion, compareDesktopVersion, NATIVE_APP_MIN_VERSION_FOR_ATA } from "@/util/helper";
import { ChildResponse, DeviceType } from "@/openapi";

export const useAtaWizard = (child: ChildResponse | null) => {
  const [isLoading, setIsLoading] = useState(false);

  const ataSupported = useMemo(() => {
    const appVersion = getReactNativeAppVersion();
    return deviceType === DeviceType.Mobile && !!appVersion && compareDesktopVersion(appVersion, NATIVE_APP_MIN_VERSION_FOR_ATA);
  }, []);

  const openAtaWizard = useCallback(async () => {
    if (!child?.id) return;
    setIsLoading(true);
    try {
      const token = await getRefreshedAccessToken();
      if (!token) return;
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({
          type: "openAtaWizard",
          data: { childId: child.id, token },
        }),
      );
    } catch (error) {
      await handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  }, [child]);

  return { openAtaWizard, isLoading, ataSupported };
};
